import { CircularPulsingIcon } from '@va/icons';
import { Chip } from '../../../chip';

type LiveChipProps = {
  label: string;
};

export const LiveChip = ({ label }: LiveChipProps) => {
  return (
    <Chip
      className='!rounded-full !bg-primary text-white'
      size='small'
      icon={<CircularPulsingIcon className='w-15px h-15px' />}
    >
      {label}
    </Chip>
  );
};
